import { createFileRoute } from "@tanstack/react-router";

import { OrgChartPage } from "../tools/okrs/OrgChartPage";

function OkrsOrgChartRouteView() {
  return <OrgChartPage />;
}

export const Route = createFileRoute("/_app/okrs/org-chart")({
  component: OkrsOrgChartRouteView,
});
